// Sticky Header Funktionalität
export function setupStickyHeader() {
    const header = document.getElementById("site-header");
    if (!header) return;

    let prevScrollpos = window.scrollY;
    let ticking = false;

    function updateHeader() {
        const currentScrollPos = window.scrollY;
        const isMenuOpen = document.body.classList.contains("menuOpen");

        header.classList.remove("is-header-visible", "is-header-hidden");

        if (currentScrollPos === 0 || isMenuOpen) {
            // Keine Klasse, um Status neutral zu halten
        } else if (prevScrollpos > currentScrollPos) {
            header.classList.add("is-header-visible");
        } else {
            header.classList.add("is-header-hidden");
        }

        prevScrollpos = currentScrollPos;
        ticking = false;
    }

    window.addEventListener("scroll", () => {
        if (!ticking) {
            ticking = true;
            window.requestAnimationFrame(updateHeader);
        }
    });
}

// Funktion, um die mobile Navigation zu toggeln
function toggleMobileNav() {
    const mobileNav = document.getElementById("site-mobilenav");
    const body = document.body;
    if (!mobileNav) return;

    const isOpen = mobileNav.classList.contains("is-visible");

    mobileNav.classList.toggle("is-visible", !isOpen);
    mobileNav.classList.toggle("is-hidden", isOpen);

    body.classList.toggle("menuOpen", !isOpen);
    body.classList.toggle("overflow-hidden", !isOpen);
}

// Event Listener für den Toggle-Button
const mobileToggle = document.getElementById("mobileToggle");
if (mobileToggle) {
    mobileToggle.addEventListener("click", toggleMobileNav);
}

// Event Delegation für Links im mobilen Menü
const mobileNav = document.getElementById("site-mobilenav");
if (mobileNav) {
    mobileNav.addEventListener("click", (event) => {
        const link = event.target.closest("a");
        if (link) {
            const href = link.getAttribute("href");
            if (href && (href.startsWith("#") || href.startsWith("/#"))) {
                toggleMobileNav();
            }
        }
    });
}